import { AccountAuthorizationsContext } from 'core/cuenta/contexts/AccountAuthorizationsContext';
import { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { formatCurrency } from 'shared/utils';

export const AccountDetailsAuthorizations = () => {
  const { authorizations } = useContext(AccountAuthorizationsContext);
  return (
    <Card>
      <Card.Header className="text-center">
        {authorizations.denominacionCuenta}
      </Card.Header>
      <Card.Body>
        <p className="fw-semibold text-center">
          Autorizaciones Cuenta: {authorizations.numeroCuenta}
        </p>
        <p className="fw-semibold text-center">
          Denominación: {authorizations.denominacionCuenta}
        </p>
        <p className="fw-semibold text-center">
          Disponible: {formatCurrency(authorizations.saldoDisponible)}
        </p>
        <p className="fw-semibold text-center">
          Total autorizaciones: {formatCurrency(authorizations.saldoAutorizaciones)}
        </p>
      </Card.Body>
    </Card>
  );
};
